import { FormControl, FormHelperText, InputLabel, Stack } from '@mui/material'
import { PropsWithChildren } from 'react'

import Tooltip from 'components/Tooltip'
import { inputWidth, InputWidth } from 'providers/material-ui/theme/constants'
import { SelectProps } from '../types'

export type Props<T> = Pick<
  SelectProps<T>,
  'disabled' | 'error' | 'helperText' | 'label' | 'name' | 'tooltip'
> &
  PropsWithChildren & {
    width?: InputWidth
  }

export const SelectContainer = <T,>({
  children,
  disabled,
  error,
  helperText,
  label,
  name,
  tooltip,
  width,
}: Props<T>): React.JSX.Element => {
  const calculatedWidth: number | string = inputWidth[width ?? 'md']

  return (
    <Stack
      direction='row'
      sx={{
        '.MuiFormControl-root': {
          minWidth: calculatedWidth,
          width: calculatedWidth,
        },
      }}
    >
      <FormControl
        data-cy={`select-${name}`}
        error={error}
      >
        {label && (
          <InputLabel
            data-cy={`select-label-${name}`}
            disabled={disabled}
            id={`${name}-label`}
            shrink
          >
            {label}
          </InputLabel>
        )}

        {children}

        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>

      {tooltip && <Tooltip {...tooltip} />}
    </Stack>
  )
}
